import React from "react";

const baseProps = {
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};

const icons = {
  chevronDown: (
    <polyline points="6 9 12 15 18 9" />
  ),
  home: (
    <>
      <path d="M3 11 12 4l9 7" />
      <path d="M5 10v10h14V10" />
    </>
  ),
  lightbulb: (
    <>
      <path d="M9 18h6" />
      <path d="M10 22h4" />
      <path d="M12 2a7 7 0 0 0-4 12c.7.6 1 1.3 1 2h6c0-.7.3-1.4 1-2a7 7 0 0 0-4-12z" />
    </>
  ),
  rocket: (
    <>
      <path d="M5 19c1.5-1 3-1 4.5-.5" />
      <path d="M14.5 9.5 19 5a9 9 0 0 0-8.5 2.5L8 10l-1.5 5L11 13.5" />
      <circle cx="15" cy="9" r="1.2" fill="currentColor" stroke="none" />
    </>
  ),
  sparkles: (
    <>
      <path d="M12 3l1.8 4.2L18 9l-4.2 1.8L12 15l-1.8-4.2L6 9l4.2-1.8L12 3z" />
      <path d="M19 15l.9 2.1L22 18l-2.1.9L19 21l-.9-2.1L16 18l2.1-.9L19 15z" />
    </>
  ),
  folder: (
    <>
      <path d="M3 7h6l2 2h10v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7z" />
    </>
  ),
  fileText: (
    <>
      <path d="M14 2H7a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7z" />
      <path d="M14 2v5h5" />
      <path d="M9 13h6" />
      <path d="M9 17h6" />
    </>
  ),
  star: (
    <path d="M12 3.5 14.8 9l6 .9-4.3 4.2 1 5.9L12 17l-5.5 3 1-5.9L3.2 9.9l6-.9L12 3.5z" />
  ),
  check: (
    <polyline points="20 6 9 17 4 12" />
  ),
  clock: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 7v6l4 2" />
    </>
  ),
  close: (
    <>
      <line x1="18" y1="6" x2="6" y2="18" />
      <line x1="6" y1="6" x2="18" y2="18" />
    </>
  ),
  mail: (
    <>
      <rect x="3" y="5" width="18" height="14" rx="2" />
      <path d="m4 7 8 6 8-6" />
    </>
  ),
  bell: (
    <>
      <path d="M15 17H9l-1-2v-4a4 4 0 1 1 8 0v4z" />
      <path d="M10 19a2 2 0 0 0 4 0" />
    </>
  ),
  search: (
    <>
      <circle cx="11" cy="11" r="7" />
      <line x1="20" y1="20" x2="16.5" y2="16.5" />
    </>
  ),
  settings: (
    <>
      <circle cx="12" cy="12" r="3" />
      <path d="M19.4 15a1 1 0 0 0 .2 1.1l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1 1 0 0 0-1.1-.2 1 1 0 0 0-.6.9V20a2 2 0 1 1-4 0v-.2a1 1 0 0 0-.6-.9 1 1 0 0 0-1.1.2l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1a1 1 0 0 0 .2-1.1 1 1 0 0 0-.9-.6H4a2 2 0 1 1 0-4h.2a1 1 0 0 0 .9-.6 1 1 0 0 0-.2-1.1l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1a1 1 0 0 0 1.1.2 1 1 0 0 0 .6-.9V4a2 2 0 1 1 4 0v.2a1 1 0 0 0 .6.9 1 1 0 0 0 1.1-.2l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1 1 0 0 0-.2 1.1 1 1 0 0 0 .9.6H20a2 2 0 1 1 0 4h-.2a1 1 0 0 0-.9.6z" />
    </>
  ),
  dot: (
    <circle cx="12" cy="12" r="4" fill="currentColor" stroke="none" />
  ),
  image: (
    <>
      <rect x="3" y="5" width="18" height="14" rx="2" />
      <circle cx="9" cy="10" r="1.5" fill="currentColor" stroke="none" />
      <path d="m21 15-4-4-5 5-2-2-5 5" />
    </>
  ),
  arrowUp: (
    <>
      <line x1="12" y1="19" x2="12" y2="5" />
      <polyline points="6 11 12 5 18 11" />
    </>
  ),
  arrowLeft: (
    <>
      <line x1="19" y1="12" x2="5" y2="12" />
      <polyline points="11 6 5 12 11 18" />
    </>
  ),
  arrowRight: (
    <>
      <line x1="5" y1="12" x2="19" y2="12" />
      <polyline points="13 6 19 12 13 18" />
    </>
  ),
  gift: (
    <>
      <rect x="3" y="9" width="18" height="12" rx="2" />
      <path d="M12 9v12" />
      <path d="M3 13h18" />
      <path d="M7.5 9a2.5 2.5 0 1 1 0-5c1.7 0 3 2 4.5 5" />
      <path d="M16.5 9a2.5 2.5 0 1 0 0-5c-1.7 0-3 2-4.5 5" />
    </>
  ),
  warning: (
    <>
      <path d="M12 3 2 21h20L12 3z" />
      <line x1="12" y1="9" x2="12" y2="14" />
      <circle cx="12" cy="17" r="1" fill="currentColor" stroke="none" />
    </>
  ),
  info: (
    <>
      <circle cx="12" cy="12" r="9" />
      <line x1="12" y1="10" x2="12" y2="16" />
      <circle cx="12" cy="7" r="1" fill="currentColor" stroke="none" />
    </>
  ),
  users: (
    <>
      <circle cx="9" cy="8" r="3" />
      <path d="M3 20a6 6 0 0 1 12 0" />
      <circle cx="17" cy="9" r="2.5" />
      <path d="M14.5 20a5 5 0 0 1 7 0" />
    </>
  ),
  link: (
    <>
      <path d="M10 13a5 5 0 0 1 0-7l1.5-1.5a5 5 0 0 1 7 7L17 13" />
      <path d="M14 11a5 5 0 0 1 0 7L12.5 19.5a5 5 0 0 1-7-7L7 11" />
    </>
  ),
  bolt: (
    <path d="M13 2 4 14h6l-1 8 9-12h-6l1-8z" />
  ),
  wifi: (
    <>
      <path d="M2 8a16 16 0 0 1 20 0" />
      <path d="M5 12a11 11 0 0 1 14 0" />
      <path d="M8.5 16a6 6 0 0 1 7 0" />
      <circle cx="12" cy="20" r="1" fill="currentColor" stroke="none" />
    </>
  ),
  play: (
    <polygon points="9 7 18 12 9 17 9 7" fill="currentColor" stroke="none" />
  ),
  music: (
    <>
      <path d="M9 18a2 2 0 1 1-4 0 2 2 0 0 1 4 0z" />
      <path d="M17 16a2 2 0 1 1-4 0 2 2 0 0 1 4 0z" />
      <path d="M9 18V6l8-2v12" />
    </>
  ),
  book: (
    <>
      <path d="M4 5a2 2 0 0 1 2-2h12v18H6a2 2 0 0 0-2 2V5z" />
      <path d="M8 7h7" />
      <path d="M8 11h7" />
    </>
  ),
  chat: (
    <>
      <path d="M4 5h16v10H8l-4 4V5z" />
    </>
  ),
  target: (
    <>
      <circle cx="12" cy="12" r="8" />
      <circle cx="12" cy="12" r="4" />
      <circle cx="12" cy="12" r="1" fill="currentColor" stroke="none" />
    </>
  ),
  pin: (
    <>
      <path d="M12 22s6-5.4 6-11a6 6 0 1 0-12 0c0 5.6 6 11 6 11z" />
      <circle cx="12" cy="11" r="2" fill="currentColor" stroke="none" />
    </>
  ),
  tool: (
    <>
      <path d="M14 7 7 14" />
      <path d="M16 5a3 3 0 0 1 3 3l-2 2-4-4 2-2a3 3 0 0 1 1-1z" />
      <path d="M3 21l4-1 11-11-3-3L4 17l-1 4z" />
    </>
  ),
  alert: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 7v6" />
      <circle cx="12" cy="16.5" r="1" fill="currentColor" stroke="none" />
    </>
  ),
  timer: (
    <>
      <circle cx="12" cy="13" r="8" />
      <line x1="12" y1="13" x2="16" y2="11" />
      <path d="M9 2h6" />
      <path d="M12 2v3" />
    </>
  ),
  github: (
    <>
      <path d="M9 19c-4 .8-4-2-6-2" />
      <path d="M15 21v-3a4 4 0 0 0-1.2-3.1c4-.4 8.2-2 8.2-9a7 7 0 0 0-2-4.8 6.6 6.6 0 0 0-.1-4.9s-1.6-.5-5.1 2a17.2 17.2 0 0 0-9.4 0c-3.5-2.5-5.1-2-5.1-2A6.6 6.6 0 0 0 .2 8a7 7 0 0 0-2 4.8c0 7 4.2 8.6 8.2 9A4 4 0 0 0 7.2 18v3" transform="translate(2 1) scale(.82)" />
    </>
  ),
  brandX: (
    <>
      <path d="M4 4h4l4 5 4-5h4l-6 7 6 9h-4l-4-6-4 6H4l6-9-6-7z" />
    </>
  ),
  briefcase: (
    <>
      <rect x="3" y="7" width="18" height="13" rx="2" />
      <path d="M9 7V5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
      <path d="M3 12h18" />
    </>
  ),
  heart: (
    <path d="M12 21s-7-4.6-9-8.9A5.5 5.5 0 0 1 12 5a5.5 5.5 0 0 1 9 7.1C19 16.4 12 21 12 21z" />
  ),
  palette: (
    <>
      <path d="M12 3a9 9 0 1 0 0 18h1a3 3 0 0 0 0-6h-1a2 2 0 0 1 0-4h3a4 4 0 0 0 0-8h-3z" />
      <circle cx="8" cy="9" r="1" fill="currentColor" stroke="none" />
      <circle cx="7" cy="13" r="1" fill="currentColor" stroke="none" />
      <circle cx="11" cy="7" r="1" fill="currentColor" stroke="none" />
    </>
  ),
  laptop: (
    <>
      <rect x="4" y="6" width="16" height="10" rx="1" />
      <path d="M2 19h20" />
    </>
  ),
  mobile: (
    <>
      <rect x="8" y="3" width="8" height="18" rx="2" />
      <circle cx="12" cy="17.5" r=".8" fill="currentColor" stroke="none" />
    </>
  ),
  pencil: (
    <>
      <path d="M3 21l3.5-1 10-10-2.5-2.5-10 10L3 21z" />
      <path d="m13.5 5.5 2.5 2.5" />
    </>
  ),
  party: (
    <>
      <path d="M5 3h4l10 10-4 4L5 7V3z" />
      <path d="M15 7l2-2" />
      <path d="M18 10l3-1" />
      <path d="M14 3l1-3" />
    </>
  )
};

function Icon({ name, className = "", size = 20, title }) {
  const glyph = icons[name] || icons.dot;

  return (
    <svg
      {...baseProps}
      width={size}
      height={size}
      className={className}
      aria-hidden={title ? undefined : true}
      role={title ? "img" : "presentation"}
    >
      {title ? <title>{title}</title> : null}
      {glyph}
    </svg>
  );
}

export default Icon;
